import React from 'react';

import { InputStyled } from './styles';

const Input = (props) => <InputStyled {...props} />;

export default Input;
